import React, { useMemo } from 'react';

import { Col } from 'antd';

import HistoryDetailsItems from './HistoryDetailsItems';
import HistoryDetailsItemsSubFields from './HistoryDetailsItemsSubFields';
import type { ChangeLogHistory, ChangeLogHistoryItemValue } from '../constants';

type ChangesListProps = {
  changelog: ChangeLogHistory[];
  filteredField: string;
};

function ChangesList({ changelog, filteredField }: ChangesListProps) {
  const filteredList = useMemo(
    () =>
      changelog.filter(history => {
        if (filteredField !== '0') return history.field === filteredField;
        return history;
      }),
    [changelog, filteredField]
  );

  if (!filteredList.length) return <Col>Nenhuma alteração para ser exibida</Col>;

  return (
    <>
      {filteredList.map(history => {
        if (!!history.values) return <HistoryDetailsItemsSubFields key={history.field} history={history} />;
        return (
          <HistoryDetailsItems
            key={history.field}
            field={history.field}
            change={{ ...history } as ChangeLogHistoryItemValue}
          />
        );
      })}
    </>
  );
}

export default ChangesList;
